import { cn } from "../../lib/utils.js";

/**
 * Contiguous page chrome: emphasized header + divider + white toolbar.
 * Matches Campaigns/Contacts — no gray gap between the two sections.
 */
export function ReportPageChrome({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div className={cn("shrink-0", className)} data-testid="reports-page-chrome">
      {children}
    </div>
  );
}
